import { getTranslate } from 'legacy-src/utilities/i18n'
import Image from 'next/image'
import React from 'react'

import useFlags from '@/legacy-src/hooks/useFlags'

import Icon from '../icons/Icon'
import { VIDEO_LESSON_TYPE } from '../premiumContent/premiumContent.constants'
import { type AuthorType, type StrapiVideoLessonType } from './types'

type Props = {
  readonly lesson: StrapiVideoLessonType
  readonly author: AuthorType
  readonly isLocked: boolean
}

const LessonTeaser: React.FC<Props> = ({ lesson, author, isLocked }) => {
  const { t } = getTranslate()
  const { allowPoshurshemo } = useFlags()

  const TEASER_HEIGHT = 320

  const imageHeight = author?.thumbnail?.data?.attributes?.height
  const imageWidth = author?.thumbnail?.data?.attributes?.width
  const imageScr = author?.thumbnail?.data?.attributes?.url

  const brand = allowPoshurshemo ? VIDEO_LESSON_TYPE.POSHURSHEMO : VIDEO_LESSON_TYPE.BRAINEE

  const calculatedHeight = Math.min(TEASER_HEIGHT, imageHeight)
  const calculatedWidth = Math.min((TEASER_HEIGHT * imageWidth) / imageHeight, imageWidth)

  return (
    <div className="relative mb-6 h-[320px] w-full rounded-3xl bg-petrol-500 tablet:flex">
      <div className="z-20 mx-6 mr-20 overflow-visible py-6 tablet:mr-48">
        <div className="flex">
          <div className="shrink rounded-md bg-peach-500 px-2 text-sm font-bold text-white">
            {t(`component.premiumContent.${brand}.tag`)}
          </div>
        </div>
        <div className="my-3 text-xl font-semibold text-white big-phone:text-3xl">{lesson?.title}</div>
        <div className="text-base font-bold text-blue-500">{author?.name}</div>
        <div className="absolute bottom-6 left-6 flex">
          {lesson.videoSection?.videoLength !== undefined && lesson.videoSection?.videoLength !== null && (
            <div className="mt-2 flex shrink items-center rounded-lg bg-white bg-opacity-10 px-3 py-2 text-sm font-bold text-white">
              <Icon icon="clock" color="primary" size="md" className="mr-3" />
              {t('component.premiumContent.lessonFooter.minutePlural', {
                count: lesson.videoSection.videoLength,
              })}
            </div>
          )}
        </div>
        {isLocked && (
          <div className="absolute bottom-6 right-6 z-10 flex shrink rounded-full bg-white bg-opacity-100">
            <Icon icon="lock-alt" color="primary" size="md" className="m-6" />
          </div>
        )}
      </div>

      {imageScr && (
        <div className="-ml-2 max-h-[320px]">
          <Image
            alt={author.name}
            src={imageScr}
            className="absolute bottom-0 right-0 z-0 rounded-br-3xl pl-24 big-phone:pl-10 laptop:pl-0"
            height={calculatedHeight}
            width={calculatedWidth}
          />
        </div>
      )}
    </div>
  )
}

export default LessonTeaser
